// extracted by mini-css-extract-plugin
export default {"analyticsAlert":"Alert_analyticsAlert__Vdtpx","new-header-values":"Alert_new-header-values__Z0fpO"};